module.exports = __webpack_public_path__ + "static/media/leaf_dark.173f02d7.png";